export const APP_ROUTES = {
  INDEX: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  ANY: '*',
  PROFILE: '/profile',
  PRODUCTS: '/products',
  CART: '/cart',
  CATEGORIES: '/categories',
} as const;
